import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import randomstring from 'uuid/v4';

class Filter extends React.Component {
    state = {
        client:
            this.props.session && this.props.session.info
                ? this.props.session.info.idCliente
                : undefined,
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (value) => (event) => {
        console.log(value);
        this.props.onClose(value);
    };

    render() {
        const { client } = this.state;
        const { intl, clients } = this.props;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_32 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="client">
                                {intl.formatMessage({ id: 'clients' })}
                            </InputLabel>
                            <Select
                                native
                                value={client}
                                onChange={this.handleChange}
                                inputProps={{ name: 'client', id: 'client-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {clients &&
                                    clients.map((c) => {
                                        return (
                                            <option key={randomstring()} value={c.id}>
                                                {c.nombre}
                                            </option>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button onClick={this.handleClose(client)} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
    info: PropTypes.object.isRequired,
    clients: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
        session: state.session,
        clients: state.clients,
    };
};

Filter = connect(
    mapStateToProps,
    null,
)(Filter);

Filter = injectIntl(Filter);

export default Filter;



// WEBPACK FOOTER //
// ./src/components/complex/manage/customers/ClientsDialog.js